
define('template!adminGenericEmailDomainsListHeaderToolsView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<button class="btn btn-primary btn-create">' +
((__t = ( _.escape(createLabel) )) == null ? '' : __t) +
'</button>\n';

}
return __p
};});

